import fetchUrl, { fetchJson } from 'utils/fetch';

export const fetch = () => fetchJson('/deployments.json');

export const deploy = () =>
  fetchUrl('/deployments.json', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./src/modules/catalog/api/deployments.js